export enum EBannerType {
  MortgageBroker,
  SubsidisedMortgage,
  CianDobro,
  DailyRent,
}
